// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__K0CRX","title":"Card_title__DlnmL"};